module.exports = __webpack_public_path__ + "img/socialLogo.783a38f2.svg";